// components/NotificationPermission.tsx
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const NotificationPermission = () => {
  const [open, setOpen] = useState(false);
  const [permissionGranted, setPermissionGranted] = useState(false);

  useEffect(() => {
    // Check if we've already asked for permission
    const askedBefore = localStorage.getItem('askedForSoundPermission');
    const audioPermission = localStorage.getItem('soundPermission') === 'granted';
    
    if (!askedBefore && !audioPermission) {
      setOpen(true);
      localStorage.setItem('askedForSoundPermission', 'true');
    }
    setPermissionGranted(audioPermission);
  }, []);

  const handleAllow = () => {
    // Create and immediately play/pause audio to trigger permission
    const audio = new Audio('/sounds/notification.mp3');
    audio.volume = 0.5; // Lower volume for permission request
    
    audio.play()
      .then(() => {
        audio.pause();
        localStorage.setItem('soundPermission', 'granted');
        setPermissionGranted(true);
      })
      .catch(err => {
        console.warn('Audio permission denied:', err);
        localStorage.setItem('soundPermission', 'denied');
      })
      .finally(() => {
        setOpen(false);
      });
  };

  const handleDeny = () => {
    localStorage.setItem('soundPermission', 'denied');
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleDeny}>
      <DialogTitle>Enable Notification Sounds?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Would you like to enable notification sounds for new orders? 
          This requires your permission to play sounds.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeny}>No Thanks</Button>
        <Button onClick={handleAllow} color="primary" variant="contained">
          Allow Sounds
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationPermission;